module.exports = __webpack_public_path__ + "img/about-3.d6322e94.png";